export default __webpack_public_path__ + "e909f3bc2a0b64c624b234b91235b256.svg";